// Let's try to keep most of the React Query keys as their related resources names in plural or singular
// depending on the context. For example, if we are fetching a list of questionnaires, the key should be
// 'QUESTIONNAIRES' and if we are fetching a single questionnaire, the key should be 'QUESTIONNAIRE'.
export enum QueryKeys {
  ASSESSMENTS_CONTROLLER = 'ASSESSMENTS_CONTROLLER',
  CLINICAL_MY_QUESTIONNAIRES = 'CLINICAL_MY_QUESTIONNAIRES',
  CLINICAL_ALL_QUESTIONNAIRE_RESPONSES = 'CLINICAL_ALL_QUESTIONNAIRE_RESPONSES',
  LATEST_QUESTIONNAIRE_RESPONSES = 'LATEST_QUESTIONNAIRE_RESPONSES',
  QUESTIONNAIRE_RESPONSES = 'QUESTIONNAIRE_RESPONSES',
  QUESTIONNAIRE_RESPONSE = 'QUESTIONNAIRE_RESPONSE',
  ASSESSMENT_LAYOUT = 'ASSESSMENT_LAYOUT',
  ASSESSMENT_LATEST_VERSION = 'ASSESSMENT_LATEST_VERSION',
  QUESTIONNAIRE_BY_VERSION = 'QUESTIONNAIRE_BY_VERSION',
  QUESTIONNAIRE_BY_IDENTIFIER = 'QUESTIONNAIRE_BY_IDENTIFIER',
  ASSESSMENT_DEPENDENT_QUESTIONNAIRE_RESPONSES = 'ASSESSMENT_DEPENDENT_QUESTIONNAIRE_RESPONSES',
  ALL_QUESTIONNAIRE_RESPONSES = 'ALL_QUESTIONNAIRE_RESPONSES',
  SERVICE_REQUESTS = 'SERVICE_REQUESTS',
  AUTHORIZATIONS = 'AUTHORIZATIONS',
  ORDER = 'ORDER',
  PRACTITIONERS = 'PRACTITIONERS',
  EMPLOYEES = 'EMPLOYEES',
  PRACTITIONER_ROLES = 'PRACTITIONER_ROLES',
  CARE_TEAMS = 'CARE_TEAMS',
  CARE_PERIODS = 'CARE_PERIODS',
  PATIENTS = 'PATIENTS',
  PATIENT_NAMES = 'PATIENT_NAMES',
  PATIENT_DATA = 'PATIENT_DATA',
  PATIENT_DATA_PATIENT = 'PATIENT_DATA_PATIENT',
  PATIENT_CHART = 'PATIENT_CHART',
  PATIENT_PROFILE = 'PATIENT_PROFILE',
  PATIENT_SOR_LINK = 'PATIENT_SOR_LINK',
  PATIENT_MEDPLUM_LINK_STATUS = 'PATIENT_MEDPLUM_LINK_STATUS',
  CAREGIVER_SOR_LINK = 'CAREGIVER_SOR_LINK',
  CAREGIVER_MEDPLUM_LINK_STATUS = 'CAREGIVER_MEDPLUM_LINK_STATUS',
  INTERACTIONS = 'INTERACTIONS',
  HEALTHCARE_SERVICES = 'HEALTHCARE_SERVICES',
  ORGANIZATIONS = 'ORGANIZATIONS',
  ORGANIZATION = 'ORGANIZATION',
  PRACTITIONER_BACKGROUND = 'PRACTITIONER_BACKGROUND',
  PRACTITIONER = 'PRACTITIONER',
  LOCATIONS = 'LOCATIONS',
  TASKS = 'TASKS',
  FLOWS = 'FLOWS',
  DATA_COMPLETENESS_VALIDATION = 'DATA_COMPLETENESS_VALIDATION',
  DIAGNOSES = 'DIAGNOSES',
  EQUIPMENT = 'EQUIPMENT',
  MEDICATIONS = 'MEDICATIONS',
  LIVE_PATIENT_RECORD = 'LIVE_PATIENT_RECORD',
  FLOW = 'FLOW',
  STAGE = 'STAGE',
  DOCUMENTS = 'DOCUMENTS',
  ASSESSMENT_COMPLETENESS_VALIDATION = 'ASSESSMENT_COMPLETENESS_VALIDATION',
  INTERVENTIONS = 'INTERVENTIONS',
  ORDER_PATIENT_CHART_VALIDATION = 'ORDER_PATIENT_CHART_VALIDATION',
  CONSENTS = 'CONSENTS',
  APPOINTMENTS = 'APPOINTMENTS',
  APPOINTMENT_TYPES = 'APPOINTMENT_TYPES',
  CHARTING_VALIDATION = 'CHARTING_VALIDATION',
  DOCUMENT_VALIDATION = 'DOCUMENT_VALIDATION',
  CLINICAL_PRACTITIONERS = 'CLINICAL_PRACTITIONERS',
  CERTIFICATION_PERIODS = 'CERTIFICATION_PERIODS',
  ACUTE_PERIODS = 'ACUTE_PERIODS',
  PATIENT_CARE_PLAN = 'PATIENT_CARE_PLAN',
  FIELD_REPORTS = 'FIELD_REPORTS',
  PATIENT_SOC_QUESTIONNAIRE_RESPONSE_IDS = 'PATIENT_SOC_QUESTIONNAIRE_RESPONSE_IDS',
  PATIENT_TASKS = 'PATIENT_TASKS',
  FIELD_REPORTS_STATES = 'FIELD_REPORTS_STATES',
  ADL_NEEDS = 'ADL_NEEDS',
  PATIENT_ADL_NEEDS = 'PATIENT_ADL_NEEDS',
  PATIENT_ADL_NEED = 'PATIENT_ADL_NEED',
  EMPLOYEE_PERMISSIONS = 'EMPLOYEE_PERMISSIONS',
  PATIENT_CHART_V2 = 'PATIENT_CHART_V2',
  TESTING_PATIENTS = 'TESTING_PATIENTS',
  CERTIFICATION_PERIOD = 'CERTIFICATION_PERIOD',
  PATIENT_NOTES = 'PATIENT_NOTES',
  COMPLETED_CARE_ASSESSMENTS = 'COMPLETED_CARE_ASSESSMENTS',
  PROCEDURE_CODES = 'PROCEDURE_CODES',
  DOCUMENT_REQUESTS = 'DOCUMENT_REQUESTS',
  DOCUMENT_REQUEST_HISTORY = 'DOCUMENT_REQUEST_HISTORY',
  VISIT_EDIT_CODES = 'VISIT_EDIT_CODES',
  COPILOT_SOURCES = 'COPILOT_SOURCES',
  VISIT_TRANSFER_CANDIDATES = 'VISIT_TRANSFER_CANDIDATES',
  PATIENT_PAR_READINESS = 'PATIENT_PAR_READINESS'
}
